import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
// icon
import MenuIcon from '@material-ui/icons/Menu';
import Icon from '@material-ui/core/Icon'
import Exit from '@material-ui/icons/ExitToApp';
import { connect } from 'react-redux';
import { logout } from "../../actions/auth";

const styles = theme => ({
  root: {

  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  iconSmall: {
    fontSize: 20,
  },
  menu: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: 20,
  },
})

class Header extends Component {

  render() {
    const { classes, handleToggle, auth, logout } = this.props;
    return (
      <div className={classes.root}>
        <AppBar position="static">
          <Toolbar>
            <IconButton className={classes.menuButton} color="inherit" aria-label="Menu" onClick={handleToggle}>
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" color="inherit" className={classes.grow}>
              Tracking System
            </Typography>
            <div variant="title" color="inherit" className='header-block'>
              <ul className={classes.menu} style={{ listStyleType: 'none' }}>
                <li className="user__img">
                  <Icon className={classes.leftIcon}>verified_user</Icon>
                </li>
                <li className="user__block">
                  <div className="user__jobTitle">
                    {auth.groups['0']}
                  </div>
                  <div className="user__fullname truncate">
                    {auth.username}
                  </div>
                </li>
              </ul>
            </div>
            <Button variant="contained" color="primary" onClick={logout}>
              <Exit className={classes.leftIcon} /> Вийти
            </Button>
          </Toolbar>
        </AppBar>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
})

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout()),
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Header))


// WEBPACK FOOTER //
// ./src/components/Header/Header.js